import type { PoseSource } from '../protocol.ts';

export interface PosePathSummary {
  count: number;
  p50?: number;
  p95?: number;
}

const percentile = (values: readonly number[], fraction: number): number | undefined => {
  if (values.length === 0) return undefined;
  const sorted = [...values].sort((a, b) => a - b);
  return sorted[Math.min(sorted.length - 1, Math.ceil(sorted.length * fraction) - 1)];
};

export class PosePathTracker {
  readonly #samples: Record<PoseSource, number[]> = {
    'data-channel': [],
    'laptop-rederives': [],
  };

  add(source: PoseSource, milliseconds: number): void {
    if (!Number.isFinite(milliseconds) || milliseconds < 0 || milliseconds > 10_000) return;
    const samples = this.#samples[source];
    samples.push(milliseconds);
    if (samples.length > 600) samples.splice(0, samples.length - 600);
  }

  summary(source: PoseSource): PosePathSummary {
    const samples = this.#samples[source];
    return { count: samples.length, p50: percentile(samples, 0.5), p95: percentile(samples, 0.95) };
  }

  delta(): { p50?: number; p95?: number } {
    const data = this.summary('data-channel');
    const laptop = this.summary('laptop-rederives');
    return {
      p50: data.p50 === undefined || laptop.p50 === undefined ? undefined : laptop.p50 - data.p50,
      p95: data.p95 === undefined || laptop.p95 === undefined ? undefined : laptop.p95 - data.p95,
    };
  }
}
